import posterImg from '../../../img/soldOut2025a.jpg';

let Registration = () => {

    return (
        <>
            <div className="registration-container">
               
                 <h5 className="mb-1 registerText center">  All-In For Autism Charity Poker Tournament is officially at capacity, and online registrations are now closed, but <span className="important-txt">YOU CAN STILL PLAY.</span> Please arrive<span className="important-txt"> before the tournament begins</span> to be added to our on-site waitlist  <span className="important-txt">(first come, first in).</span> </h5>
                <ul className="left">
                    <li className="mb-1 "><span className="important-txt">Cash only </span> at the tournament</li>
                    <li className="mb-1 ">Seats always open up due to last-minute no-shows</li>
                    <li className="mb-1 "><span className="important-txt">We GUARANTEE that everyone on the wait list before the start of the tournament will get a seat</span></li>
                </ul>
                <h5 className="mb-1 registerText center">For more information, please contact Anthony Hale at 602-435-1251 or Anthony@ARFHelps.org.</h5>
                {/*<h5 className="mb-1 registerText" ><span className="important-txt">*Note*</span> If you <span className="important-txt">DO NOT</span> want to contribute to Zeffy:</h5>
                <h5 className="mb-1 registerText">1. In the Order Summary section, right of Support the 100% free platform we use! select <span className="important-txt">OTHER</span> in the dropdown box.</h5>
                <h5 className="mb-3 registerText">2. In the Contribution box, type the number <span className="important-txt">0 (zero).</span></h5>
                
                <h5 className="mb-1 registerText"><span className="important-txt bold">Please note: All donations are final and greatly appreciated.</span></h5> 

                <img className="home-page-image" alt="poker registration " src={posterImg}/>
            
                */}

                 {/* <div className="zeffyThings1">
                    <iframe title='Donation form powered by Zeffy' className="zeffyThings2" src='https://www.zeffy.com/embed/ticketing/2026-all-in-for-autism-charity-poker-tournament' allowpaymentrequest allowTransparency="true">
                    </iframe>
                </div>  */}
            </div>
        </>
    );

}

export default Registration;